export function BudgetSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/budget.svg'"></ng-include>`
    }
}